import { render, staticRenderFns } from "./PreviewMediaModal.vue?vue&type=template&id=3dd3da10&"
import script from "./PreviewMediaModal.vue?vue&type=script&lang=js&"
export * from "./PreviewMediaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports